import request, { HttpMethod } from '@app/libs/request';
import config, { serverUrl } from '@app/config';
import { TenantUserServerResponse, UpdateWebUserRolesRequest } from '@app/domain/userManagement/users';

export async function searchTenantUsers(query: string): Promise<TenantUserServerResponse[]> {
  return request<TenantUserServerResponse[]>(serverUrl, `/api/users`, {
    params: { query },
    method: HttpMethod.get,
    errorsHandler: {
      RETURNED_TOO_MANY_USERS_ERROR: {
        suppressNotification: true,
      },
      default: {
        message: 'Cannot search users.',
      },
    },
  });
}

export async function updateGlobalUserRoles(
  tenantUserId: string,
  data: UpdateWebUserRolesRequest,
): Promise<TenantUserServerResponse> {
  return request<TenantUserServerResponse>(config.serverUrls.backee, `/api/users/:tenantUserId/global-web-app-roles`, {
    data,
    method: HttpMethod.patch,
    pathParams: { tenantUserId },
    errorsHandler: {
      default: {
        message: 'Cannot update the global roles of the user.',
      },
    },
  });
}
